import { z } from 'zod';

export const HardwareMountingProfileSchema = z.object({
  id: z.string().uuid(),
  hardware_id: z.string().uuid(),
  profile_name: z.string().default('Default'),
  mount_surface: z.string().default('Door Panel'),
  mount_face: z.string().default('front'),
  align_x: z.string().default('middle'),
  align_y: z.string().default('middle'),
  align_z: z.string().default('front'),
  offset_x: z.number().default(0),
  offset_y: z.number().default(0),
  offset_z: z.number().default(0),
  rotation_x: z.number().default(0),
  rotation_y: z.number().default(0),
  rotation_z: z.number().default(0),
  mirror_mode: z.string().default('none'),
  mirror_centerline: z.string().default('cabinet'),
  pattern_qty: z.number().int().default(1),
  pattern_spacing_x: z.number().default(0),
  pattern_spacing_y: z.number().default(0),
  pattern_spacing_z: z.number().default(0),
  quantity_rule: z.string().default('fixed'),
  quantity_value: z.number().int().default(1),
  quantity_formula: z.string().default(''),
  spacing_min: z.number().default(0),
  spacing_max: z.number().default(0),
  condition_field: z.string().default(''),
  condition_operator: z.string().default(''),
  condition_value: z.number().default(0),
  extra_qty_per_condition: z.number().int().default(0),
  distribute_enabled: z.boolean().default(false),
  distribute_qty: z.number().int().min(2).default(2),
  notes: z.string().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateHardwareMountingProfileSchema = z.object({
  hardware_id: z.string().uuid(),
  profile_name: z.string().min(1, 'Profile name is required'),
  mount_surface: z.string().default('Door Panel'),
  mount_face: z.string().default('front'),
  align_x: z.string().default('middle'),
  align_y: z.string().default('middle'),
  align_z: z.string().default('front'),
  offset_x: z.number().default(0),
  offset_y: z.number().default(0),
  offset_z: z.number().default(0),
  rotation_x: z.number().default(0),
  rotation_y: z.number().default(0),
  rotation_z: z.number().default(0),
  mirror_mode: z.string().default('none'),
  mirror_centerline: z.string().default('cabinet'),
  pattern_qty: z.number().int().default(1),
  pattern_spacing_x: z.number().default(0),
  pattern_spacing_y: z.number().default(0),
  pattern_spacing_z: z.number().default(0),
  quantity_rule: z.string().default('fixed'),
  quantity_value: z.number().int().default(1),
  quantity_formula: z.string().default(''),
  spacing_min: z.number().default(0),
  spacing_max: z.number().default(0),
  condition_field: z.string().default(''),
  condition_operator: z.string().default(''),
  condition_value: z.number().default(0),
  extra_qty_per_condition: z.number().int().default(0),
  distribute_enabled: z.boolean().default(false),
  distribute_qty: z.number().int().min(2).default(2),
  notes: z.string().nullable().optional(),
});

export const UpdateHardwareMountingProfileSchema = CreateHardwareMountingProfileSchema.omit({ hardware_id: true }).partial();

export type HardwareMountingProfile = z.infer<typeof HardwareMountingProfileSchema>;
export type CreateHardwareMountingProfile = z.infer<typeof CreateHardwareMountingProfileSchema>;
export type UpdateHardwareMountingProfile = z.infer<typeof UpdateHardwareMountingProfileSchema>;
